<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const baseConfig = parseAndValidateConverterConfig('tiff-to-pdf-converter', 'TIFF to PDF');

// Merge base config with TIFF→PDF specific labels
const converterConfig = {
  ...baseConfig,
  jobCategory: 'image.tiff-to-pdf',
  labels: {
    dropzoneHeading: 'Drop TIFF Files Here',
    emptyQueueMessage: 'Drop TIFF files to convert to PDF.',
    statsLabel: 'Median TIFF to PDF time (last 10k jobs): {p50TimeMs}',
    batchCompleteTitle: 'All {n} files converted successfully!',
    batchInProgressTitle: 'Converting {n} files to PDF...',
  },
  supportUrl: '/contact',
  pricingUrl: '/pricing',
};

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[TIFF to PDF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[TIFF to PDF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[TIFF to PDF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[TIFF to PDF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[TIFF to PDF Converter] Credits updated:', credits);
}
</script>
